/**
 * Created by eriksundqvist on 24/05/16.
 */
import { connect } from 'react-redux';
import { setAmount, setCurrencyId, setCurrencyName, setCurrencyAmount, setTaxId } from 'redux/modules/invoice/index';
import Amount from './amount';

function mapStateToProps (state) {
  return {
    amount: state.invoice.amount,
    currencyId: state.invoice.currencyId,
    currencyName: state.invoice.currencyName,
    currencyAmount: state.invoice.currencyAmount,
    user: state.user,
    invoice: state.invoice,
    taxkeys: state.taxkeys,
    submitted: state.invoice.submitted
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAmount: (amount) => dispatch(setAmount(amount)),
    setCurrencyId: (currencyId) => dispatch(setCurrencyId(currencyId)),
    setCurrencyName: (currencyName) => dispatch(setCurrencyName(currencyName)),
    setCurrencyAmount: (currencyAmount) => dispatch(setCurrencyAmount(currencyAmount)),
    setTaxId: (taxId) => dispatch(setTaxId(taxId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Amount);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/amount/amount-container.js
 **/